import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { AdminSugerenciasMonitoreoContent } from './components/AdminSugerenciasMonitoreoContent';

export default function AdminSugerenciasMonitoreo() {

    return (
        <MainContent
            component={<AdminSugerenciasMonitoreoContent />}
            titulo='Admin. Sugerencias Monitoreo'
            noBackground
            tableMaxWidth
        />
    );

};
